var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarSide = function SvgCarSide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4667_21755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58008 20.5C6.82272 20.5 7.83008 19.4926 7.83008 18.25C7.83008 17.0074 6.82272 16 5.58008 16C4.33744 16 3.33008 17.0074 3.33008 18.25C3.33008 19.4926 4.33744 20.5 5.58008 20.5Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0801 20.5C20.3227 20.5 21.3301 19.4926 21.3301 18.25C21.3301 17.0074 20.3227 16 19.0801 16C17.8374 16 16.8301 17.0074 16.8301 18.25C16.8301 19.4926 17.8374 20.5 19.0801 20.5Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08008 10.0001H12.6301C12.9262 10.0001 13.2157 9.91238 13.4621 9.74809L14.9561 8.74809C15.2025 8.58381 15.492 8.49613 15.7881 8.49609H22.0881C22.4859 8.49609 22.8674 8.65413 23.1487 8.93543C23.43 9.21674 23.5881 9.59827 23.5881 9.99609V15.2461C23.0643 14.5457 22.3837 13.9777 21.6008 13.5877C20.818 13.1977 19.9547 12.9964 19.0801 13.0001C18.2336 12.9996 17.3995 13.204 16.6492 13.5958C15.8988 13.9876 15.2544 14.5552 14.7711 15.2501H9.88908C9.40571 14.5552 8.76133 13.9876 8.01097 13.5958C7.26062 13.204 6.42657 12.9996 5.58008 13.0001C4.70648 12.9981 3.84455 13.2006 3.06317 13.5913C2.2818 13.982 1.60267 14.55 1.08008 15.2501V10.0001Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5801 8.5L16.3911 5.088C16.3016 4.77461 16.1124 4.4989 15.8522 4.3026C15.592 4.10629 15.275 4.00007 14.9491 4H4.94908C4.68502 4.00044 4.42576 4.07057 4.19749 4.20332C3.96923 4.33606 3.78005 4.52671 3.64908 4.756L1.08008 10",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08008 4V10",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4667_21755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.330078)"
  })))));
};
export default SvgCarSide;